
import './App.css';
import ShoppingList from './einkaufsliste';

function App() {
  return (
    <div className="App">
      <header className="App-header">

      </header>
      <ShoppingList />
    </div>
  );
}

export default App;
